// MultiSelectDropdown.tsx
import React, { useState } from "react";
import Select, { MultiValue } from "react-select";
import { useTranslation } from "../hooks/hooks";
import { activeProvidersAtom, providersAtom } from "../state/games";
import { getOptionsForProviders } from "../helpers/helpers";
import { useAtom } from "jotai";

const ProvidersDropdown = () => {
    const { _e } = useTranslation();
    const [providers] = useAtom(providersAtom);
    const [activeProviders, setActiveProviders] = useAtom(activeProvidersAtom);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const options = providers ? getOptionsForProviders(providers, activeProviders, false) : [];
    const selected = providers ? getOptionsForProviders(providers, activeProviders, true) : null;

    const handleChange = (selected: MultiValue<{ value: number; label: string }>) => {
        if (selected.length) {
            const prs = selected.map(option => option.value);
            setActiveProviders(prs);
        }
    };
    const customStyles = {
        menu: (provided: any, state: any) => ({
            ...provided,
            zIndex: "20",
        }),
    };
    return (
        <div className={menuIsOpen ? "select-dropdown-wrapper open" : "select-dropdown-wrapper"}>
            <Select
                isMulti
                options={options}
                hideSelectedOptions={false}
                value={selected}
                onChange={handleChange}
                controlShouldRenderValue={false}
                placeholder={_e("Providers")}
                closeMenuOnSelect={false}
                styles={customStyles}
                classNamePrefix="select-dropdown"
                isClearable={false}
                onMenuOpen={() => setMenuIsOpen(true)}
                onMenuClose={() => setMenuIsOpen(false)}
            />
        </div>
    );
};

export default ProvidersDropdown;
